/**
 * @generated SignedSource<<64ddee7bd58b44bac972d8b1e6217533>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailReference_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailItemInvoice_user">;
  readonly " $fragmentType": "PdpSharedDetailReference_user";
};
export type PdpSharedDetailReference_user$key = {
  readonly " $data"?: PdpSharedDetailReference_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailReference_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailReference_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailItemInvoice_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "240620978a1a7e3a4b00cfdd667faab9";

export default node;
